import { Modal, Icon, LabelMenuOption } from '@chikara/ui';
import styles from '@/features/card/pages/CardDetailPage/CardDetailPage.module.css';
import { t } from '@/i18n';

interface ManageTagsModalProps {
    isOpen: boolean;
    onClose: () => void;
    tags: LabelMenuOption[];
    onEditTag: (tagName: string) => void;
    onDeleteTag: (tagName: string) => Promise<void>;
}

export const ManageTagsModal = ({
    isOpen,
    onClose,
    tags,
    onEditTag,
    onDeleteTag,
}: ManageTagsModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('dashboard.card.detail.modals.manageTags.title')}
            description={
                <div className={styles.editAliasContent}>
                    <p className={styles.editAliasDescription}>
                        {t('dashboard.card.detail.modals.manageTags.description')}
                    </p>
                    <div className={styles.tagsList}>
                        {tags.map((tag) => (
                            <div key={tag.value} className={styles.tagItem}>
                                <span className={styles.tagName}>{tag.label}</span>
                                <div className={styles.tagActions}>
                                    <button
                                        type="button"
                                        onClick={() => onEditTag(tag.label)}
                                        className={styles.tagActionButton}
                                        aria-label={t('dashboard.card.detail.info.edit')}
                                    >
                                        <Icon name="edit" size="sm" />
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => onDeleteTag(tag.label)}
                                        className={styles.tagActionButton}
                                        aria-label={t('dashboard.card.detail.actions.cancel')}
                                    >
                                        <Icon name="close" size="sm" />
                                    </button>
                                </div>
                            </div>
                        ))}
                        {tags.length === 0 && (
                            <p className={styles.noOptions}>{t('common.noOptions') || 'Sin registros'}</p>
                        )}
                    </div>
                </div>
            }
            showCloseButton={true}
            closeOnOverlayClick={true}
            closeOnEsc={true}
        />
    );
};
